import Model from "@/models/Model"

/**
 * @model Permission
 * @see models/permission
 */
export default class Permission extends Model {

    resource() {
        return "permission"
    }
}